import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { uiActions } from '../../store/ui-slice';

import Button from '../commons/Button';

const GenericError = () => {
  const dispatch = useDispatch();
  const { title, body, specialContent, onCloseNavigate, isMessageHidden } = useSelector((state) => state.ui.errorStatus);

  const renderBodyJSX = () => {
    if (isMessageHidden) {
      return null;
    }

    if (body.indexOf('%%' !== -1)) {
      return body.split('%%').map((msg) => <p className="body" key={msg}>{msg}</p>);
    }
    if (body) {
      return <p className="body">body</p>;
    }
    return <p className="body">Intenta actualizar la página o intentar nuevamente más adelante.</p>;
  };

  const renderSpecialContent = () => {
    if (!specialContent || !specialContent.textParts || !specialContent.buttons) {
      return null;
    }

    const { textParts = [], buttons = [] } = specialContent || {};

    return (
      <>
        <p className="body">
          {textParts.map((part) => {
            if (typeof part === 'string') {
              return part;
            }
            if (part.bold && part.lineBreak) {
              return (
                <span key={part}>
                  <br />
                  <span className="label">{part.bold}</span>
                </span>
              );
            }
            if (part.bold) {
              return <span key={part} className="label">{part.bold}</span>;
            }
            return null;
          })}
        </p>
        {buttons?.length && buttons.map((button) => {
          return (
            <Button
              key={button.label}
              label={button.label}
              onClick={button.action}
              buttonClasses={button?.buttonClasses ?? 'align-center'}
              iconClasses={button.icon}
              iconPosition="after" />
          );
        })}
      </>
    );
  };

  const onClickReset = () => {
    const linkToNavigate = onCloseNavigate;
    dispatch(uiActions.clearErrorStatus());

    // The linkToNavigate is expected to be an isolated case for returning,
    // as this component does not have access to the React Router context.
    // That's why the # in the URLs is used as a reference point. This way,
    // we maintain the server URL where it is located
    // The reload is necessary to clear the application's state
    if (linkToNavigate) {
      const currentUrl = window.location.href;
      const hashIndex = currentUrl.indexOf('#');

      let newUrl;
      if (hashIndex !== -1) {
        newUrl = `${currentUrl.substring(0, hashIndex)}#${linkToNavigate}`;
      } else {
        newUrl = `${currentUrl}#${onCloseNavigate}`;
      }

      window.location.assign(newUrl);
      window.location.reload();
    }
  };

  return (
    <div className="generic-error">
      <h2 className="title">{title || 'Ocurrió un error'}</h2>
      {renderBodyJSX()}
      {renderSpecialContent()}
      <Button
        label="Cerrar"
        onClick={onClickReset}
        buttonClasses="align-center"
        iconClasses="times"
        iconPosition="after" />
    </div>
  );
};

export default GenericError;
